(() => {
  const selector = '[data-cart-promo-progress]';

  const render = (element, count) => {
    const target = Number(element.dataset.promoTarget || 3);
    const remaining = Math.max(target - count, 0);
    const message = element.querySelector('[data-promo-message]');
    const countLabel = element.querySelector('[data-promo-count]');
    const bar = element.querySelector('[data-promo-bar]');

    if (message) {
      message.textContent = remaining === 0
        ? 'YOU UNLOCKED 20% OFF'
        : `BUY ${remaining} MORE TO GET 20% OFF`;
    }
    if (countLabel) countLabel.textContent = `${Math.min(count, target)}/${target}`;
    if (bar) bar.style.width = `${Math.min((count / target) * 100, 100)}%`;
    element.dataset.promoCount = String(count);
  };

  const renderAll = (count) => {
    document.querySelectorAll(selector).forEach((element) => render(element, count));
  };

  const refresh = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    renderAll(Number(cart.item_count || 0));
  };

  document.addEventListener('minus:cart-updated', (event) => {
    if (typeof event.detail?.item_count === 'number') renderAll(event.detail.item_count);
    else refresh();
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-cart-quantity-input]')) return;
    const total = Array.from(document.querySelectorAll('[data-cart-quantity-input]'))
      .reduce((sum, input) => sum + Number(input.value || 0), 0);
    renderAll(total);
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-cart-quantity-minus], [data-cart-quantity-plus]')) return;
    window.setTimeout(() => {
      const total = Array.from(document.querySelectorAll('[data-cart-quantity-input]'))
        .reduce((sum, input) => sum + Number(input.value || 0), 0);
      renderAll(total);
    });
  });

  document.addEventListener('DOMContentLoaded', refresh);
})();
